var map = {
	"./404.svg": "./src/icons/svg/404.svg",
	"./bug.svg": "./src/icons/svg/bug.svg",
	"./build.svg": "./src/icons/svg/build.svg",
	"./business-center.svg": "./src/icons/svg/business-center.svg",
	"./cascader.svg": "./src/icons/svg/cascader.svg",
	"./chart.svg": "./src/icons/svg/chart.svg",
	"./checkbox.svg": "./src/icons/svg/checkbox.svg",
	"./clipboard.svg": "./src/icons/svg/clipboard.svg",
	"./code.svg": "./src/icons/svg/code.svg",
	"./color.svg": "./src/icons/svg/color.svg",
	"./component.svg": "./src/icons/svg/component.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./date-range.svg": "./src/icons/svg/date-range.svg",
	"./date.svg": "./src/icons/svg/date.svg",
	"./dict.svg": "./src/icons/svg/dict.svg",
	"./documentation.svg": "./src/icons/svg/documentation.svg",
	"./download.svg": "./src/icons/svg/download.svg",
	"./drag.svg": "./src/icons/svg/drag.svg",
	"./druid.svg": "./src/icons/svg/druid.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./education.svg": "./src/icons/svg/education.svg",
	"./email.svg": "./src/icons/svg/email.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./excel.svg": "./src/icons/svg/excel.svg",
	"./exit-fullscreen.svg": "./src/icons/svg/exit-fullscreen.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./fullscreen.svg": "./src/icons/svg/fullscreen.svg",
	"./github.svg": "./src/icons/svg/github.svg",
	"./guide.svg": "./src/icons/svg/guide.svg",
	"./html.svg": "./src/icons/svg/html.svg",
	"./icon.svg": "./src/icons/svg/icon.svg",
	"./input.svg": "./src/icons/svg/input.svg",
	"./international.svg": "./src/icons/svg/international.svg",
	"./job.svg": "./src/icons/svg/job.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./list.svg": "./src/icons/svg/list.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./log.svg": "./src/icons/svg/log.svg",
	"./logininfor.svg": "./src/icons/svg/logininfor.svg",
	"./logout.svg": "./src/icons/svg/logout.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./money.svg": "./src/icons/svg/money.svg",
	"./monitor.svg": "./src/icons/svg/monitor.svg",
	"./more.svg": "./src/icons/svg/more.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./number.svg": "./src/icons/svg/number.svg",
	"./online.svg": "./src/icons/svg/online.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./pdf.svg": "./src/icons/svg/pdf.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./peoples.svg": "./src/icons/svg/peoples.svg",
	"./phone.svg": "./src/icons/svg/phone.svg",
	"./pointer.svg": "./src/icons/svg/pointer.svg",
	"./post.svg": "./src/icons/svg/post.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./question.svg": "./src/icons/svg/question.svg",
	"./radio.svg": "./src/icons/svg/radio.svg",
	"./rate.svg": "./src/icons/svg/rate.svg",
	"./row.svg": "./src/icons/svg/row.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./select.svg": "./src/icons/svg/select.svg",
	"./server.svg": "./src/icons/svg/server.svg",
	"./setting-center.svg": "./src/icons/svg/setting-center.svg",
	"./shopping.svg": "./src/icons/svg/shopping.svg",
	"./size.svg": "./src/icons/svg/size.svg",
	"./skill.svg": "./src/icons/svg/skill.svg",
	"./slider.svg": "./src/icons/svg/slider.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./swagger.svg": "./src/icons/svg/swagger.svg",
	"./switch.svg": "./src/icons/svg/switch.svg",
	"./system.svg": "./src/icons/svg/system.svg",
	"./tab.svg": "./src/icons/svg/tab.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./textarea.svg": "./src/icons/svg/textarea.svg",
	"./theme.svg": "./src/icons/svg/theme.svg",
	"./time-range.svg": "./src/icons/svg/time-range.svg",
	"./time.svg": "./src/icons/svg/time.svg",
	"./tool.svg": "./src/icons/svg/tool.svg",
	"./tree-table.svg": "./src/icons/svg/tree-table.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./upload.svg": "./src/icons/svg/upload.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./validCode.svg": "./src/icons/svg/validCode.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg",
	"./word.svg": "./src/icons/svg/word.svg",
	"./zip.svg": "./src/icons/svg/zip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";